import styled from 'styled-components';
import { OptionLabel } from '../accordionCheckboxOption/accordionCheckboxOption.styles';

export const Container = styled.li`
  cursor: pointer;
  display: flex;
  padding: 14px 0;
  line-height: 22px;
  align-items: center;
  font-size: 16px;
`;

export const SubOptionLabel = styled(OptionLabel)``;
